// extracted by mini-css-extract-plugin
export default {"side-bar":"styles_side-bar__8Obx9","side-bar__section":"styles_side-bar__section__12tQV","schedule-section":"styles_schedule-section__wh7O9"};